<div class="content-wrapper">
    <div class="content-body">
        <div id="user-profile">
            <div class="row">
                <div class="col-12">
                    <button class="btn btn-icon btn-flat-primary mb-1" type="button" (click)="goBack()">
                        <i data-feather="arrow-left" class="mr-8px"></i>&nbsp;Back to Popular Courses
                    </button>
                    <div class="card profile-header mb-2">

                        <div class="profile-title-row p-2 pb-0 d-flex align-items-center">
                            <div class="profile-img-container align-items-center mr-2">
                                <div class="profile-img">
                                    <img src="{{popularCourse?.popular_course_file?.url}}" class="rounded img-fluid" alt="Card image" />
                                </div>
                            </div>
                            <p class="mb-0 font-weight-bold text-truncate">{{popularCourse?.short_name}}</p>
                        </div>

                        <div class="profile-header-nav d-flex align-items-center">
                            <nav class="navbar navbar-expand-md navbar-light justify-content-end justify-content-md-between w-100">
                                <button
                                        class="btn btn-icon navbar-toggler"
                                        type="button"
                                        data-target="#navbarSupportedContent"
                                        aria-controls="navbarSupportedContent"
                                        aria-expanded="false"
                                        aria-label="Toggle navigation"
                                        (click)="toggleMenu = !toggleMenu"
                                        rippleEffect
                                >
                                    <i data-feather="align-justify" class="font-medium-5"></i>
                                </button>
                                <div class="collapse navbar-collapse" id="navbarSupportedContent"
                                     [ngbCollapse]="toggleMenu">
                                    <div class="profile-tabs d-flex justify-content-between flex-wrap mt-1 mt-md-0">
                                        <ul class="nav nav-pills mb-0">
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="overview" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Overview</span>
                                                    <i data-feather="rss" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="eligibility-duration" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Eligibility/Duration</span>
                                                    <i data-feather="check-square" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="fee-structure" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Fee Structure</span>
                                                    <i data-feather="dollar-sign" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="top-universities" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Top Universities</span>
                                                    <i data-feather="home" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="admission-process" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Admission Process</span>
                                                    <i data-feather="clipboard" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="subject-syllabus" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Subject & Syllabus</span>
                                                    <i data-feather="book-open" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="benefits" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Course Benefits</span>
                                                    <i data-feather="award" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="career" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Jobs & Salaries</span>
                                                    <i data-feather="briefcase" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="why-us" routerLinkActive="active">
                                                    <span class="d-none d-md-block">How To Choose</span>
                                                    <i data-feather="thumbs-up" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="faqs" routerLinkActive="active">
                                                    <span class="d-none d-md-block">FAQs</span>
                                                    <i data-feather="help-circle" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <router-outlet></router-outlet>
        </div>
    </div>
</div>
